import { Injectable } from '@angular/core';
import {
  ConfigBaseFilter,
  ConfigService,
  ListLayout,
  ListLayoutMultipleComponent,
  ListSortOption,
  SimpleConfigBaseFilter
} from 'gung-list';
import { Observable } from 'rxjs';
import { ReturnOrderCardListComponent } from '../../components/return-order-card-list/return-order-card-list.component';
import { ReturnOrder } from '../../models/return-order';
import { ReturnOrderService } from '../return-orders/return-order.service';
import { SelectedCustomerService } from '../selected-customer/selected-customer.service';
import { DateUtilService } from 'gung-common';

export class ReturnOrderDateFilter extends SimpleConfigBaseFilter<ReturnOrder> {
  type = 'dateRangeFilter';
  constructor(protected dateUtilService: DateUtilService) {
    super();
  }

  getOptionIds(item: ReturnOrder): string[] {
    if (item.returnDate) {
      return [this.dateUtilService.getFormattedDateString(new Date(item.returnDate), 'yyMMdd')];
    }
    return [];
  }
  getOptionName(key: string): string {
    return key;
  }
  getName(): string {
    return 'RETURN_DATE';
  }
}

@Injectable({
  providedIn: 'root'
})
export class ReturnOrderListConfigService implements ConfigService<ReturnOrder> {
  customerId: string;
  topFilter = true;

  setCustomerId(customerId: string) {
    this.customerId = customerId;
  }

  constructor(
    protected returnOrderService: ReturnOrderService,
    protected selectedCustomerService: SelectedCustomerService,
    protected dateUtilService: DateUtilService
  ) {}

  getItems(): Observable<ReturnOrder[]> {
    if (this.customerId != null) {
      return this.returnOrderService.getReturnOrders(this.customerId);
    }
    return this.returnOrderService.getAllReturnOrders();
  }

  getFilters(): ConfigBaseFilter<ReturnOrder>[] {
    return [
      new ReturnOrderDateFilter(this.dateUtilService)
    ];
  }

  getSortOptions(): ListSortOption<ReturnOrder>[] {
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }

  getLayouts(): ListLayout<ReturnOrder>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => ReturnOrderCardListComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Return order list'
      }
    ];
  }

  getSearchTerms(item: ReturnOrder): string[] {
    return [item.id];
  }

  getItemId(item: ReturnOrder): string {
    return item.id;
  }

  getNothingFoundTranslateTag() {
    return 'NOTHING_FOUND';
  }
}
